import * as s from "protobufjs/minimal.js";
const r = "default" in s ? s.default : s;
var c;
(function(e) {
  e[e.ACTIVATION_STATUS_DO_NOT_USE = 0] = "ACTIVATION_STATUS_DO_NOT_USE", e[e.INACTIVE = 1] = "INACTIVE", e[e.ACTIVE = 2] = "ACTIVE", e[e.DEACTIVATED = 3] = "DEACTIVATED";
})(c || (c = {}));
var f;
(function(e) {
  e[e.FEATURE_SET_DO_NOT_USE = 0] = "FEATURE_SET_DO_NOT_USE", e[e.APPOINTMENTS = 1] = "APPOINTMENTS", e[e.RESTAURANTS = 2] = "RESTAURANTS", e[e.RETAIL = 3] = "RETAIL";
})(f || (f = {}));
function d() {
  return {
    $type: "squareup.featurama.feature_sets.FeatureSetActivationStatusForSeller",
    activationStatus: void 0,
    isActive: void 0
  };
}
const u = {
  $type: "squareup.featurama.feature_sets.FeatureSetActivationStatusForSeller",
  encode(e, t = r.Writer.create()) {
    return e.activationStatus !== void 0 && t.uint32(8).int32(e.activationStatus), e.isActive !== void 0 && t.uint32(16).bool(e.isActive), t;
  },
  decode(e, t) {
    const a = e instanceof r.Reader ? e : r.Reader.create(e);
    let o = t === void 0 ? a.len : a.pos + t;
    const i = d();
    for (; a.pos < o; ) {
      const n = a.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 8)
            break;
          i.activationStatus = a.int32();
          continue;
        case 2:
          if (n !== 16)
            break;
          i.isActive = a.bool();
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      a.skipType(n & 7);
    }
    return i;
  },
  create(e) {
    return u.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = d();
    return t.activationStatus = e.activationStatus ?? void 0, t.isActive = e.isActive ?? void 0, t;
  }
};
function S() {
  return {
    $type: "squareup.featurama.feature_sets.FeatureSetStatusForSeller",
    featureSetKey: void 0,
    activationStatus: void 0
  };
}
const T = {
  $type: "squareup.featurama.feature_sets.FeatureSetStatusForSeller",
  encode(e, t = r.Writer.create()) {
    return e.featureSetKey !== void 0 && t.uint32(8).int32(e.featureSetKey), e.activationStatus !== void 0 && u.encode(e.activationStatus, t.uint32(18).fork()).ldelim(), t;
  },
  decode(e, t) {
    const a = e instanceof r.Reader ? e : r.Reader.create(e);
    let o = t === void 0 ? a.len : a.pos + t;
    const i = S();
    for (; a.pos < o; ) {
      const n = a.uint32();
      switch (n >>> 3) {
        case 1:
          if (n !== 8)
            break;
          i.featureSetKey = a.int32();
          continue;
        case 2:
          if (n !== 18)
            break;
          i.activationStatus = u.decode(a, a.uint32());
          continue;
      }
      if ((n & 7) === 4 || n === 0)
        break;
      a.skipType(n & 7);
    }
    return i;
  },
  create(e) {
    return T.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const t = S();
    return t.featureSetKey = e.featureSetKey ?? void 0, t.activationStatus = e.activationStatus !== void 0 && e.activationStatus !== null ? u.fromPartial(e.activationStatus) : void 0, t;
  }
};
export {
  c as ActivationStatus,
  u as FeatureSetActivationStatusForSeller,
  f as FeatureSetKey,
  T as FeatureSetStatusForSeller
};
